import React from 'react';
import PropTypes from 'prop-types';

import InputFilter from './InputFilter';
import FilterByCategory from './FilterByCategory';

import Box from '@mui/material/Box';

const Sidebar = (props) => {
	const { currentCategory, handleFilterByCategory, handleFilterByInput } = props;

	return (
		<Box minWidth='230px'>
			<InputFilter handleFilterByInput={handleFilterByInput} />
			<FilterByCategory
				currentCategory={currentCategory}
				handleFilterByCategory={handleFilterByCategory}
			/>
		</Box>
	);
};

Sidebar.propTypes = {
	currentCategory: PropTypes.string,
	handleFilterByCategory: PropTypes.func,
	handleFilterByInput: PropTypes.func
};

export default Sidebar;
